// Meta Pixel helper — fires conversion events for Facebook ads.
export const firePixel = (event, data = {}) => {
  try {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", event, data);
    }
  } catch (e) {
    // no-op
  }
  // Always log for debugging / verification
  // eslint-disable-next-line no-console
  console.log("Meta Pixel: Conversion Fired ->", event, data);
};
